
export const LOGIN_SIGNIN_LINK = `https://c10in1.avetti.ca/preview//uservices/1.0.2/signin/20151203508/`;

export const LOGIN_CHECK_LINK = `https://c10in1.avetti.ca/preview//uservices/1.0.2/login/20151203508/`;

export const LOGOUT_LINK = `https://c10in1.avetti.ca/preview//uservices/1.0.2/signout/20151203508/`;